import { render, staticRenderFns } from "./2_information.vue?vue&type=template&id=7b81c00f&scoped=true&"
import script from "./2_information.vue?vue&type=script&lang=js&"
export * from "./2_information.vue?vue&type=script&lang=js&"
import style0 from "./2_information.vue?vue&type=style&index=0&id=7b81c00f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b81c00f",
  null
  
)

export default component.exports